<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
會員中心              </p>
	</div>
   <div class="mem-full">

 <Center title='7' />

<div class="mem-con">
	<div class="address">
		<div class="men-l1">
			<div class="re-tit">
					   <h4>驗證郵箱</h4>
			</div>
			<div class="re-con">
				<div class="password">
				
				<el-form :model="ruleForm" label-width="150px"  size="mini">
				
						
				  <el-form-item label="驗證郵箱:" prop="email">
				  {{user.email}}
				  </el-form-item>
				  <el-row gutter="20">
					   <el-col span="14">
				  <el-form-item label="驗證碼:" prop="code">
						    <el-input v-model="ruleForm.code"></el-input>
		
				  </el-form-item>
				  </el-col>
				  <el-col span="10"><div class="h-button button2" @click="cap">獲取驗證碼</div></el-col>
				  </el-row>
				<div class="h-button" @click="next">驗證</div>
				  </el-form-item>
				</el-form>
				
			
				</div>
			</div>
		</div>
		
	</div>



	
</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center
  },
  data() {
    return {
		user:'',
		page:1,
		pagenum:100,
		moren:false,
		sun:'',
		news:'',
           ruleForm: {
           	code:''    
                 },
		form: {
			pass:'',
			confirm_pass:'',
		      },
			  rules: {
			  	
			  	  pass: [
			  	    { required: true, message: 'Please fill in password', trigger: 'blur' },
			  ],confirm_pass: [
			  	    { required: true, message: 'Please Confirm password', trigger: 'blur' },
			  ]
			   
			    }
               
          };
  },  mounted() {
	  this.user = JSON.parse(window.localStorage.getItem('user'));
	  this.id = this.$route.query.id

		
		},methods: {
			
			submitForm(formName) {
						      
			       this.$refs[formName].validate((valid) => {
			         if (valid) {
			        this.$axios({
			          method: "post",
			          url: "service.php?action=users_changePass",
			          data: this.form,  
			        }).then((res) => {
			        	let data=res.data;
			        			
			        if(data.code==1){
			        	
			        this.$message.success(data.message);
			         if (this.active++ > 2) this.active = 0;
			        		  
			        }else{  
			        	this.$message.error(data.message);
			        	      
			        }
			         
			        });
							 
							 
			         } else {
			          
			           return false;
			         }
			       });
			     },
			
			 next() {
				 if(this.ruleForm.code==''){
					 this.$message.error('Please fill in the verification code');
					 return
				 }
				 
				 this.$axios({
				   method: "post",
				   url: "service.php?action=users_verifyCode",
				   data: {code:this.ruleForm.code},  
				 }).then((res) => {
				 	let data=res.data;
				 
				 	if(data.code==1){
						this.$message.success(data.message);
						
				 		this.$router.push({ path: "/user/account" });	
				 
				 			  
				 	}else{  
				 		this.$message.error(data.message);
				 		      
				 	}
				  
				 });
				 
			       
			      },
			
		
			  full(){
				  if(this.moren){
					  this.ruleForm.moren= 1
				  }else{
					   this.ruleForm.moren= 0
				  }
			
			  },
			 sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_country",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  	
			  		if(data.code==1){
			  			this.sun=data.data;
			  		}
			  	 
			  	});
			  
			  },
			  cap(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=users_sendEmailCode",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
	
	if(data.code==1){
		
	this.$message.success(data.message);

			  
	}else{  
		this.$message.error(data.message);
		      
	}
			  		
			  	 
			  	});
			  
			  },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
		margin: 0 auto;
			text-align: center;
			cursor: pointer;
			width: 95px;
			padding: 0 50px;
			height: 31px;
			line-height: 31px;
			background: #000;
			color: #FFFFFF;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
		.button2{
			background: #e2e2e2;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
.address{
	.re-con{
	
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		.re-tit{
			line-height: 50px;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
			}
			
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	margin: 20px 0;
}
.add-set{
	margin-left: 10px;
}
.password{
	width:550px;
	margin: 100px auto;
	.pass-step{
		margin: 100px 0;
	}
}
</style>